import { alphabetize } from './sort-util';

const generateOptionsArray = <V,>(
    overwriteOptions: Array<V> | undefined,
    options: Array<V> | undefined,
    sortBy: keyof V | undefined
): Array<V> => {
    if (overwriteOptions) return overwriteOptions;
    return alphabetize(options ?? [], sortBy);
};

const generatePlaceholder = <V,>(value: Array<V> | V | null): string => {
    if (!value || (Array.isArray(value) && !value.length)) return 'All';
    return '';
};

export { generateOptionsArray, generatePlaceholder };
